import types from '../types'

const initialState = {
  /* Default values here */
  isLoading: true,
  defaultAuthForm: {
    rikaiKey: '',
    orgId: '',
    authKey: '',
  },
  authForm: {
    rikaiKey: '',
    orgId: '',
    authKey: '',
  },
  signInForm: {
    username: '',
    password: '',
  },
  theme: 'dark',
}

export default function(state = initialState, action) {
  switch (action.type) {
    case types.STORE_PAYLOAD:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
